import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { useCompanyGetAdministratedCompaniesQuery } from '../../common/redux/api/web-api'
import useText from '../../common/hooks/useText'
import { RootState } from '../redux/store'
import { Dropdown } from '../../common/uikit/Dropdown'
import currentUser from '../../lib/currentUser'
import { setUser } from '../../common/redux/features/user/userSlice'
import { triggerAuthChange } from '../../common/utils/broadcastChannel'

export const HeaderChangeOrganisationDropdown = () => {
    const text = useText()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { data: organisations, isLoading } = useCompanyGetAdministratedCompaniesQuery()

    const organisationOptions = organisations?.map((organisation) => ({
        label: organisation?.name,
        value: organisation?.id,
    }))

    const signedInUser = useSelector((state: RootState) => state.user)
    const handleChangeOrganisation = (companyId: string): void => {
        if (!signedInUser || !signedInUser.selectedCompanyId) {
            navigate('/login', { replace: true })
            return
        }

        const userAfterSelectCompany = { ...signedInUser, selectedCompanyId: companyId ?? '' }
        currentUser(userAfterSelectCompany)
        dispatch(setUser(userAfterSelectCompany))
        triggerAuthChange()
    }

    return (
        <Dropdown
            className="w-10rem md:w-auto"
            id="organisation-select"
            options={organisationOptions}
            value={signedInUser?.selectedCompanyId}
            onChange={(event) => handleChangeOrganisation(event.value)}
            loading={isLoading}
            filter
            virtualScrollerOptions={{ itemSize: 38 }}
            placeholder={text('lblSelectOrganisation')}
            showClear={false}
        ></Dropdown>
    )
}
